import React from 'react';

const CourseTitle = props => {
	const { current, content, onBack } = props;

	let currentTitleHtml = null;

	if (current) {
		const parent = content.filter(c => c.id == current).pop();
		currentTitleHtml = (
			<div className="popup-nav__title-mobile">
				<button
					onClick={() => onBack()}
					type="button"
					className="popup-nav__title-backlink"
				>
					Все курсы
				</button>
				<h4 className="heading heading--2">{parent.name}</h4>
			</div>
		);
	}

	const classes = ['heading','heading--2'];
	if (current) classes.push('no-mobile');

	return (
		<section className="popup-nav__title">
			<h4 className={classes.join(' ')}>Курсы</h4>
			{currentTitleHtml}
		</section>
	);
};

export default CourseTitle;
